/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const somnia_chain_about = () => `Somnia is the fastest and most efficient EVM Layer 1 blockchain ever, capable of processing over 400k transactions per second with sub-second finality. It is suitable for serving millions of users and building real-time mass-consumer applications like gaming, social applications, metaverses, NFTs, and more, all fully on-chain.`
